import {
	requestAchievementsFailed,
	requestAchievementsSuccess,
	requestAvatarsFailed,
	requestAvatarsSuccess,
	requestCountriesFailed,
	requestCountriesSuccess,
	requestHelpPagesFailed,
	requestHelpPagesSuccess,
	requestSettingsFailed,
	requestSettingsSuccess,
	requestTeamsFailed,
	requestTeamsSuccess,
	showErrorModal,
} from "modules/actions";
import {all, call, put} from "typed-redux-saga";
import {Api, ApiError} from "modules/utils";

export const requestSettingsSaga = function* () {
	try {
		const result = yield* call(Api.JSON.settings);

		yield* put(requestSettingsSuccess(result));
	} catch (err) {
		yield* put(requestSettingsFailed());

		if (err instanceof ApiError) {
			yield* put(
				showErrorModal({
					message: err.message,
				})
			);
		}
	}
};

export const requestTeamsSaga = function* () {
	try {
		const result = yield* call(Api.JSON.teams);
		yield* put(requestTeamsSuccess(result.favoriteTeams));
	} catch (err) {
		yield* put(requestTeamsFailed());
		const {message} = err as ApiError;
		yield* put(showErrorModal({message}));
	}
};

export const requestHelpPagesSaga = function* () {
	try {
		const {faqs, helps} = yield* all({
			faqs: call(Api.JSON.faqs),
			helps: call(Api.JSON.helps),
		});

		yield* put(
			requestHelpPagesSuccess({
				faqs,
				terms: helps.terms,
				guidelines: helps.how_to_play,
			})
		);
	} catch (err) {
		yield* put(requestHelpPagesFailed());
		const {message} = err as ApiError;
		yield* put(showErrorModal({message}));
	}
};

export const requestAvatarsSaga = function* () {
	try {
		const result = yield* call(Api.JSON.avatars);
		yield* put(requestAvatarsSuccess(result.avatars));
	} catch (err) {
		yield* put(requestAvatarsFailed());
		const {message} = err as ApiError;
		yield* put(showErrorModal({message}));
	}
};

export const requestAchievementsSaga = function* () {
	try {
		const result = yield* call(Api.JSON.achievements);
		yield* put(requestAchievementsSuccess(result.achievements));
	} catch (err) {
		yield* put(requestAchievementsFailed());
		const {message} = err as ApiError;
		yield* put(showErrorModal({message}));
	}
};

export const requestCountriesSaga = function* () {
	try {
		const result = yield* call(Api.JSON.countries);
		yield* put(requestCountriesSuccess(result));
	} catch (err) {
		yield* put(requestCountriesFailed());
		const {message} = err as ApiError;
		yield* put(showErrorModal({message}));
	}
};
